// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDm34nl8O8ZMZbN9j-yr9Qb71BWGNiWXuA',
    databaseURL: 'https://counything.firebaseio.com',
    storageBucket: 'counything.appspot.com',
    authDomain: 'counything.firebaseapp.com',
    messagingSenderId: '430289547746',
    projectId: 'counything',
  },
  dialogFlow: {
    entityId: 'ac44d231-f27d-46ba-86cc-e79f35c4777a',
    token: '3c501f3a9c5a4febb0f4ba3d6d1b4e58'
  },
  auth0: {
    clientId: 'rG5I0Ba6A2gxTqkd5DN9MsS3NCdOB67w',
    domain: 'counything.auth0.com',
  },
};



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/environments/environment.ts